import { render, staticRenderFns } from "./UserRolesPage.vue?vue&type=template&id=61713148&scoped=true"
import script from "./UserRolesPage.vue?vue&type=script&lang=ts"
export * from "./UserRolesPage.vue?vue&type=script&lang=ts"
import style0 from "./UserRolesPage.vue?vue&type=style&index=0&id=61713148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61713148",
  null
  
)

export default component.exports